import endpoints from "@/utils/constants";
import { apiHelper } from "@/utils/helpers";
import { camelToSnake } from "../../../utils/CamelToSnake";
import snakeToCamel from "../../../utils/SnakeToCamel";

const actions = {
  getPurchases(context, payload) {
    const params = new URLSearchParams(payload).toString();
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.purchases}?${params}`
        )
        .then(res => {
          if (res && res.status === 200) {
            context.commit("setPurchaseList", res.data.data);
            resolve(res.data.data); // Ensure the promise resolves
          } else {
            reject("Error fetching purchases");
          }
        })
        .catch(err => {
          if (err.response) {
            reject(err.response);
          } else {
            reject("Unknown API error");
          }
        });
    });
  },

  savePurchase(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.purchases}`,
          camelToSnake(payload)
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchPurchase(context, purchaseId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.purchases}/${purchaseId}`
        )
        .then(res => {
          if (res.status === 200) {
            // context.commit("setPurchase", res.data);
            resolve(snakeToCamel(res.data));
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updatePurchase(context, { purchaseId, payload }) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}${endpoints.API.purchases}/${purchaseId}`,
          camelToSnake(payload)
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setPurchase", res.data);
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default actions;
